import {DeadlineTool} from './features/DeadlineTool';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './app/App';
import { sendEvent } from './platform/analytics';
import { channel } from './platform/channel';
import './design/app.css';

// 진입 즉시 1회. 라우트·금고 해제 뒤로 미루면 랜딩만 보고 떠난 방문자가 빠져
// 퍼널의 분모가 사라진다.
sendEvent('app_open', 'ok', channel);

const publicGuide=document.querySelector<HTMLElement>('[data-public-guide]');
if(publicGuide){sendEvent('guide_view','ok',channel,publicGuide.dataset.publicGuide);const calculator=document.getElementById('public-deadline');if(calculator)ReactDOM.createRoot(calculator).render(<DeadlineTool/>);}else ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode><App /></React.StrictMode>);

